module.exports = new __parcel__URL__("industrial2.d0a92c30.jpg").toString();